import TomSelectBaseController from "./tom_select_base";

export default class extends TomSelectBaseController {
  get tomSelectOptions() {
    return {
      plugins: {
        checkbox_options: {
          checkedClassNames: ["ts-checked"],
          uncheckedClassNames: ["ts-unchecked"],
        },
        change_listener: {},
        clear_button: {
          title: "Remove all selected options",
          html: function (data) {
            return `<div class="${data.className}" title="${data.title}">&#65368;</div>`;
          },
        },
      },
      sortField: [{ field: "$order" }, { field: "$score" }],
    };
  }
}
